import React from 'react';
import './style.scss';

// IconList Component
const IconList = ({ section }) => (
  <div className="icon-list">
    <h3 className="icon-list_header">{section.title}</h3>
    <IconListItems items={section.listItems} />
    {section.footer && <Footer footer={section.footer} />}
  </div>
);

// IconListItems Component
const IconListItems = ({ items }) => (
  <div className="icon-list_items">
    {items.map((item, index) => (
      <IconListItem key={index} item={item} />
    ))}
  </div>
);

// IconListItem Component
const IconListItem = ({ item }) => (
  <div
    className="icon-list_item"
    style={{ backgroundColor: item.backgroundColor, color: item.fontColor }}
  >
    <Icon src={item.icon} />
    <Text text={item.text} />
  </div>
);

// Icon Component
const Icon = ({ src }) => <img className="icon" src={src} alt="icon" />;

// Text Component
const Text = ({ text, style }) => (
  <div className="text" style={style}>
    {text}
  </div>
);

// Footer Component
const Footer = ({ footer }) => (
  <div className="icon-list_footer">
    {footer.ctas.map((cta, index) => (
      <CTA key={index} cta={cta} />
    ))}
  </div>
);

// CTA Component
const CTA = ({ cta }) => (
  <a className="cta" href={cta.link} target="_blank" rel="noopener noreferrer">
    {cta.label}
  </a>
);

export default IconList;
